// "3 new matches since you previewed. A sync landed. Nothing was applied."
// (`#s07` tablet). Blocks a silent apply: the caller must not let commit
// proceed while this banner is showing -- Re-preview is the only way past it.
import { Button } from '@moneyskyline/ui';

export function AskSupersededBanner({ newMatchCount, onRepreview }: { newMatchCount: number; onRepreview: () => void }) {
  return (
    <div
      className="flex items-center gap-3 rounded-lg border border-link bg-link-surface px-3.5 py-3 text-sm"
      role="alert"
      data-testid="ask-superseded-banner"
    >
      <span className="flex-1">
        <strong>{newMatchCount} new match{newMatchCount === 1 ? '' : 'es'} since you previewed.</strong> A sync landed.
        Nothing was applied.
      </span>
      <Button type="button" size="sm" onClick={onRepreview}>
        Re-preview
      </Button>
    </div>
  );
}

export default AskSupersededBanner;
